import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const ProductCard = ({ product }) => {
  return (
    <div 
      className="bg-white rounded-lg border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1 group" 
      data-testid="product-card"
    >
      <div className="relative overflow-hidden aspect-[4/3] bg-gray-50 flex items-center justify-center p-4">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-4 right-4 bg-[#6ABD45] text-white px-4 py-1.5 rounded-md text-sm font-semibold">
          {product.category}
        </div>
      </div>
      <div className="p-8">
        <h3 className="font-semibold text-2xl mb-3 text-[#2E368F] transition-colors duration-250 group-hover:text-[#6ABD45]">
          {product.name}
        </h3>
        <p className="text-gray-600 text-sm mb-6 line-clamp-2 leading-relaxed">
          {product.description}
        </p>
        <Link
          to="/products"
          className="inline-flex items-center gap-2 text-[#6ABD45] font-semibold transition-all duration-250 group-hover:gap-3"
          data-testid="view-product-link"
        >
          <span>View Details</span>
          <FaArrowRight className="text-sm" />
        </Link>
      </div>
    </div>
  );
};

export default ProductCard;
